import { Box, InfoOutlinedIcon, Tooltip } from '@parspec/pixel';

export function InfoHeaderTemplateCallback(title: string, info: string) {
    return () => (
        <Box display="flex" width="100%" justifyContent="space-between" alignItems="center">
            <Box>{title}</Box>
            <Tooltip title={info}>
                <InfoOutlinedIcon fontSize="small" />
            </Tooltip>
        </Box>
    );
}

export function getErpContent(props: any) {
    return props?.erp_code ? props.erp_code : '--';
}

const allowedCharactersRegex = /^[A-Za-z0-9'\\\-@$:!#)?*_/,|&+<>;."%(\s]*$/;

export const isValidCharactersForMfg = (value: string): { isValid: boolean; sanitizedValue: string; } => {
    const isValid = allowedCharactersRegex.test(value);
    // Replace any characters that don't match the allowed pattern with empty space
    // const sanitizedValue = value.replace(/[^A-Za-z0-9'\\\-@$:!#)?*_/,|&+<>;."%(\s]/g, ' ').trim();
    const sanitizedValue = value.split('').filter(char => allowedCharactersRegex.test(char)).join('').trim();


    return {
        isValid,
        sanitizedValue
    };
};